<template>
    <div class="places-autocomplete">
        <input
            ref="autocompleteField"
            type="text"
            autocomplete="off"
            class="form-control"
            :placeholder="placeholder"
            :value="street"
            @blur="emitBlur"
            @change="
                (e) => {
                    $emit('update:street', e.target.value);
                }
            "
            :disabled="disabled"
        />
        <div ref="minCharsHint" class="places-autocomplete__hint" style="display: none">
            Please enter more than 3 letters to search for an address.
        </div>
    </div>
</template>

<style src="./PlacesAutocomplete.scss"></style>
<script src="./PlacesAutocomplete"></script>
